import { useState } from 'react';
import { Link, useNavigate } from 'react-router-dom';
import SiteHeader from '../components/SiteHeader';
import { DEMO_PASSWORD, DEMO_USERNAME, loginDemo } from '../utils/demoAuth';

export default function LoginPage() {
  const navigate = useNavigate();
  const [username, setUsername] = useState('');
  const [password, setPassword] = useState('');
  const [error, setError] = useState('');

  function handleSubmit(event) {
    event.preventDefault();
    if (loginDemo(username.trim(), password)) {
      navigate('/toolbox', { replace: true });
      return;
    }
    setError('Invalid demo credentials. Use administrator / administrator.');
  }

  function fillDemo() {
    setUsername(DEMO_USERNAME);
    setPassword(DEMO_PASSWORD);
    setError('');
  }

  return (
    <div className="site-page">
      <SiteHeader />
      <main className="login-main">
        <div className="login-card panel-card">
          <img src="/favicon.svg" alt="" className="login-logo" />
          <h1>Demo sign-in</h1>
          <p className="login-lead">
            Enter the demo account to explore the GIS Liberty toolbox interface.
            This is not connected to a live server.
          </p>

          <div className="demo-creds panel-card-inset">
            <strong>Demo account</strong>
            <p>
              Username: <code>{DEMO_USERNAME}</code><br />
              Password: <code>{DEMO_PASSWORD}</code>
            </p>
            <button type="button" className="btn btn-link btn-sm" onClick={fillDemo}>
              Fill credentials
            </button>
          </div>

          <form className="login-form" onSubmit={handleSubmit}>
            <label className="form-field">
              <span>Username</span>
              <input
                type="text"
                autoComplete="username"
                value={username}
                onChange={(e) => setUsername(e.target.value)}
                placeholder={DEMO_USERNAME}
              />
            </label>
            <label className="form-field">
              <span>Password</span>
              <input
                type="password"
                autoComplete="current-password"
                value={password}
                onChange={(e) => setPassword(e.target.value)}
                placeholder="••••••••••••"
              />
            </label>
            {error ? <p className="form-error">{error}</p> : null}
            <button type="submit" className="btn btn-primary btn-block">Enter demo</button>
          </form>

          <p className="login-back">
            <Link to="/">← Back to home</Link>
          </p>
        </div>
      </main>
    </div>
  );
}
